module.exports = __webpack_public_path__ + "img/itx-file-type-mka.b1f582e2.svg";